package com.nonopn.skydome.common.app.navigation

import androidx.compose.foundation.layout.fillMaxSize
import androidx.compose.material.icons.Icons
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import com.nonopn.icons.Logout
import com.nonopn.skydome.common.app.api.Mode
import com.nonopn.skydome.common.app.home.AppModel
import com.nonopn.skydome.common.app.home.LocalApp
import com.nonopn.skydome.common.app.pages.estimates.EstimatesScreen
import com.nonopn.skywatcher.common.app.res.Res
import com.nonopn.skywatcher.common.app.res.menu_user_estimate_list
import com.nonopn.skywatcher.design.appbar.AppBarState
import com.nonopn.skywatcher.design.widgets.MenuItem
import eu.codlab.navigation.NavigateTo
import eu.codlab.navigation.NavigateToStack
import eu.codlab.navigation.NavigateWithNavOptions
import eu.codlab.navigation.Route
import eu.codlab.navigation.RouteParameterTo
import eu.codlab.navigation.RouterNoParameters
import kotlinx.serialization.Serializable

@Serializable
object RouteEstimates : RouteParameterTo

object RouterEstimates : RouterNoParameters<RouteEstimates>(RouteEstimates::class) {
    override fun routeFrom(parameters: RouteEstimates) = "/estimates"

    @Composable
    override fun Show(parameters: RouteEstimates) {
        RouteEstimatesImpl().scene()
    }

    override fun navigateTo() = NavigateTo(
        route = RouteEstimates,
        stack = NavigateToStack(
            popBackStack = true,
            options = NavigateWithNavOptions(
                launchSingleTop = true
            )
        )
    )

    override fun isCurrentRoute(routeParameterTo: RouteParameterTo?) =
        null != routeParameterTo && routeParameterTo is RouteEstimates

    override fun isMatching(route: String) = route == "/estimates"

    override fun navigateFrom(path: String) = RouteEstimates
}

class RouteEstimatesImpl : Route<RouteEstimates>(
    route = "/estimates",
    params = RouteEstimates,
) {
    @Composable
    override fun scene() {
        val appModel: AppModel = LocalApp.current

        LaunchedEffect(Unit) {
            onEntryIsActive(appModel, emptyList())
        }

        val state by appModel.states.collectAsState()
        // Adding probes is restricted to admin accounts for now
        val isAdmin = state.apiProvider?.apiAdmin != null

        EstimatesScreen(
            modifier = Modifier.fillMaxSize(),
            mode = Mode.Normal,
            onCreateNewEstimate = { appModel.show(RouterEstimateNew.navigateTo()) }.takeIf { isAdmin },
        )
    }

    private fun onEntryIsActive(
        appModel: AppModel,
        defaultActions: List<MenuItem>,
    ) {
        appModel.setAppBarState(
            AppBarState.Localized(
                title = Res.string.menu_user_estimate_list,
                defaultActions + MenuItem.MenuItemSimple(
                    imageVector = Icons.Rounded.Logout,
                    onClick = {
                        // appModel.show(NavigateTo.Main())
                    }
                )
            )
        )
    }
}
